/*
 * Paper Fold step 3 demo (snippets/mogrt-demo-paper.liquid), run by
 * assets/mogrt-steps-demo.js: a picture is dragged onto the Image panel's
 * preview and takes the Placeholder's place, then the Program monitor plays
 * the template with it (assets/mogrt-paper-crumple.css): the paper ball
 * opens out into the picture, holds, crumples back.
 */
(() => {
  const parts = (screen) => ({
    thumb: screen.querySelector('[data-mdp-thumb]'),
    drop: screen.querySelector('[data-mdp-drop]'),
    reveal: screen.querySelector('[data-mdp-reveal]'),
  });
  const reset = (p) => {
    ['data-armed', 'data-play', 'data-hold'].forEach((name) => p.reveal.removeAttribute(name));
    p.thumb.classList.remove('is-shown', 'is-moving', 'is-dropped');
    p.drop.classList.remove('is-over');
  };

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.paper = {
    rest(screen) {
      reset(parts(screen));
      screen.setAttribute('data-live', '');
    },
    async pass(screen, t) {
      const p = parts(screen);
      const loop = parseFloat(getComputedStyle(p.reveal).getPropertyValue('--mpc-loop')) * 1000 || 2800;
      reset(p);
      // aim the picture at the middle of the preview
      const from = p.thumb.getBoundingClientRect();
      const to = p.drop.getBoundingClientRect();
      p.thumb.style.setProperty('--mdp-dx', `${Math.round(to.left + to.width / 2 - from.left - from.width / 2)}px`);
      p.thumb.style.setProperty('--mdp-dy', `${Math.round(to.top + to.height / 2 - from.top - from.height / 2)}px`);
      if (!(await t.wait(700))) return false;
      p.thumb.classList.add('is-shown');
      if (!(await t.wait(400))) return false;
      p.thumb.classList.add('is-moving');
      if (!(await t.wait(800))) return false;
      p.drop.classList.add('is-over');
      if (!(await t.wait(420))) return false;
      // dropped: the picture replaces the Placeholder, the template plays from the ball
      p.thumb.classList.add('is-dropped');
      p.drop.classList.remove('is-over');
      p.reveal.setAttribute('data-armed', '');
      t.live(true);
      if (!(await t.wait(600))) return false;
      p.reveal.setAttribute('data-play', '');
      // pause in the hold so the picture lies flat a little longer
      if (!(await t.wait(loop * 0.45))) return false;
      p.reveal.setAttribute('data-hold', '');
      if (!(await t.wait(1400))) return false;
      p.reveal.removeAttribute('data-hold');
      if (!(await t.wait(loop * 0.55))) return false;
      return t.wait(800);
    },
  };
})();
